// extracted by mini-css-extract-plugin
export default {"title":"TemplatesView-module__title--ZyMYB","empty":"TemplatesView-module__empty--V2N8i"};